import React, { useContext } from 'react';
import { FirebaseContext } from '.';

const SignOut = () => {
  const { auth } = useContext(FirebaseContext);

  return (
    <button className='btn btn-primary' onClick={ () => auth.signOut() }>Sign out  <i className='fab fa-google'></i></button>
  );
};

export default SignOut;
